var y = Object.defineProperty;
var b = (e, n, a) => n in e ? y(e, n, { enumerable: !0, configurable: !0, writable: !0, value: a }) : e[n] = a;
var t = (e, n, a) => b(e, typeof n != "symbol" ? n + "" : n, a);
function Ut() {
  var e;
  try {
    return typeof ((e = window == null ? void 0 : window.mixpanel) == null ? void 0 : e.get_distinct_id) == "function" ? window.mixpanel.get_distinct_id() : void 0;
  } catch (n) {
    console.error(n);
    return;
  }
}
function S() {
  var e, n;
  return typeof window < "u" && ((n = (e = window.location) == null ? void 0 : e.hostname) == null ? void 0 : n.indexOf("hs-app.local.hsenv.io")) >= 0;
}
function h() {
  return typeof window < "u" && !!window.__STORYBOOK_API__;
}
function T(e) {
  var n;
  return S() ? `${e}${((n = window.hsGlobal) == null ? void 0 : n.mixpanelSuffix) ?? ""}` : e;
}
const I = {
  identify: (e) => {
    console.log("@helpscout/analytics identify:", e);
  },
  reset: () => {
    console.log("@helpscout/analytics reset");
  },
  track: (e, n) => {
    console.log("@helpscout/analytics track:", e, n);
  }
}, R = {
  identify: () => {
  },
  reset: () => {
  },
  track: () => {
  }
};
function r() {
  var e;
  return typeof window < "u" && typeof ((e = window.mixpanel) == null ? void 0 : e.track) == "function" ? window.mixpanel : O();
}
function O() {
  return S() || h() ? I : R;
}
const P = 3e3, V = 50, _ = 500, D = 6, M = 1e3, U = "hs-mixpanel-flag-overrides", p = "hs-mixpanel-flag-cache", l = /* @__PURE__ */ new Map();
F();
let m = null;
function A(e) {
  if (typeof window > "u") return null;
  try {
    const n = window.localStorage.getItem(U);
    if (!n) return null;
    const a = JSON.parse(n), o = a == null ? void 0 : a[e];
    return typeof o == "boolean" || typeof o == "string" ? o : null;
  } catch {
    return null;
  }
}
function F() {
  if (!(typeof window > "u"))
    try {
      const e = window.sessionStorage.getItem(p);
      if (!e) return;
      const n = JSON.parse(e);
      for (const [a, o] of Object.entries(n))
        (typeof o == "boolean" || typeof o == "string") && l.set(a, o);
    } catch {
    }
}
function B(e, n) {
  if (!(typeof window > "u"))
    try {
      const a = window.sessionStorage.getItem(p), o = a ? JSON.parse(a) : {};
      o[e] = n, window.sessionStorage.setItem(p, JSON.stringify(o));
    } catch {
    }
}
async function G(e = P) {
  var a, o, i;
  if (typeof window > "u") return !1;
  const n = Date.now();
  for (; typeof ((o = (a = window.mixpanel) == null ? void 0 : a.flags) == null ? void 0 : o.get_variant_value) != "function"; ) {
    const d = Date.now() - n;
    if (typeof ((i = window.mixpanel) == null ? void 0 : i.track) != "function" && d >= _ || d >= e) return !1;
    await new Promise((E) => setTimeout(E, V));
  }
  return !0;
}
function L() {
  return m || (m = G().then((e) => (e || (m = null), e))), m;
}
async function W(e) {
  const a = await r().flags.get_variant_value(e, !1), o = typeof a == "boolean" || typeof a == "string" ? a : !1;
  return l.set(e, o), B(e, o), o;
}
async function g(e, n = 0) {
  var a;
  for (let o = 0; ; o++) {
    if (await L() && typeof ((a = r().flags) == null ? void 0 : a.get_variant_value) == "function")
      try {
        return await W(e);
      } catch (d) {
        return console.error(d), !1;
      }
    if (o >= n) return !1;
    await new Promise((i) => setTimeout(i, M));
  }
}
async function Ft(e) {
  await Promise.all(
    e.filter((n) => !l.has(n)).map((n) => g(n, D))
  );
}
function Bt(e) {
  const n = N(e);
  return n === void 0 ? void 0 : n === !0;
}
function N(e) {
  const n = A(e);
  return n !== null ? n : l.get(e);
}
async function Gt(e) {
  const n = A(e);
  return n !== null ? n === !0 : l.has(e) ? l.get(e) === !0 : await g(e) === !0;
}
const K = "user_";
function Lt(e) {
  var n, a;
  if (!e) {
    console.error(
      "@helpscout/analytics: Cannot identify user for MixPanel without a user ID"
    );
    return;
  }
  try {
    (a = (n = r()).identify) == null || a.call(
      n,
      T(`${K}${e}`)
    );
  } catch (o) {
    console.error(
      "@helpscout/analytics: Error identifying user for MixPanel",
      o
    );
  }
}
function Wt() {
  var e, n;
  try {
    (n = (e = r()).reset) == null || n.call(e);
  } catch (a) {
    console.error(
      "@helpscout/analytics: Error resetting identity for MixPanel",
      a
    );
  }
}
const Y = [
  "Clicked Button",
  "Clicked Copy Workflow Button",
  "Clicked Copy Workflow to Mailbox Button",
  "Clicked Link",
  'In App Tour "Next" Button Clicked',
  'In App Tour "Close" Button Clicked',
  "Signed Up"
];
class s {
  /**
   * Constructor for BaseEvent
   * @param properties - Properties for the event
   */
  constructor(n) {
    /** Event properties */
    t(this, "properties");
    this.properties = n;
  }
  /**
   * Get trackable properties. This is the properties that will be sent to the
   * tracking service. The default implementation adds the following properties:
   * - `companyId` - The company ID
   * - `memberId` - The member ID
   * - `userId` - The user ID
   * Override this method to add additional properties.
   * @protected
   */
  getTrackableProperties() {
    return {
      ...this.properties ?? {},
      companyId: window.hsGlobal.companyId,
      memberId: Y.includes(this.name) ? window.hsGlobal.memberId : void 0,
      userId: window.hsGlobal.memberId
    };
  }
  /**
   * Get the track function. This is the function that will be used to track the
   * event. The default implementation checks if the environment is a storybook
   * environment or a local environment. If it is a storybook environment, it
   * returns the console track function. If it is a local environment, it returns
   * the console track function. Otherwise, it returns the noop track function.
   * Override this method if you want to use a different tracking service or
   * strategy.
   * @protected
   */
  getAnalyticsService() {
    return r();
  }
  /**
   * Track the event. This is the function that will be called to track the event.
   * The default implementation adds the following properties to the trackable
   * properties:
   * - `companyId` - The company ID
   * - `memberId` - The member ID
   * - `userId` - The user ID
   *
   * @returns The current instance of the event
   */
  track() {
    try {
      const n = this.getTrackableProperties();
      this.getAnalyticsService().track(this.name, n);
    } catch (n) {
      console.error("@helpscout/analytics track failed", n);
    }
    return this;
  }
}
class $ extends s {
  constructor({
    pageVisited: a,
    state: o
  }) {
    super({
      pageVisited: a ?? (typeof window < "u" ? window.location.pathname : "/"),
      ...o && { state: o }
    });
    t(this, "name", "pageVisited");
  }
}
class v extends s {
}
class H extends v {
  constructor() {
    super(...arguments);
    t(this, "name", "Clicked Button");
  }
}
class j extends v {
  constructor() {
    super(...arguments);
    t(this, "name", "Clicked Link");
  }
}
class J extends v {
  constructor({
    step: a
  }) {
    var o, i;
    super({
      signUpStep: a,
      com_id: ((o = window.hsGlobal) == null ? void 0 : o.companyId) ?? "",
      usr_id: ((i = window.hsGlobal) == null ? void 0 : i.memberId) ?? ""
    });
    t(this, "name", "Signed Up");
  }
}
class z extends s {
  constructor(a) {
    super({
      currentAvailabilityStatus: a == null ? void 0 : a.currentAvailabilityStatus
    });
    t(this, "name", "accountDropdownOpened");
  }
}
class X extends s {
  constructor(a) {
    super({
      itemType: a.itemType,
      itemValue: a.itemValue
    });
    t(this, "name", "accountDropdownItemClicked");
  }
}
class q extends s {
  constructor(a) {
    super({
      currentStatus: a.currentStatus,
      intendedStatus: a.intendedStatus
    });
    t(this, "name", "availabilityToggleClicked");
  }
}
class Q extends s {
  constructor(a) {
    super({
      previousStatus: a.previousStatus,
      newStatus: a.newStatus,
      success: a.success,
      errorType: a.errorType
    });
    t(this, "name", "availabilityChanged");
  }
}
class Z extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicsEnabled");
  }
}
class ee extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicsDisabled");
  }
}
class ne extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicsDeleted");
  }
}
class te extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicsAppliedToInbox");
  }
}
class se extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicsReviewNotificationClicked");
  }
}
class ae extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicUserCreated");
  }
}
class oe extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicUserModified");
  }
}
class ie extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicConvoOverride");
  }
}
class de extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicValueEnabled");
  }
}
class le extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicValueDisabled");
  }
}
class ce extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicUsedSearch");
  }
}
class re extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicUsedReports");
  }
}
class me extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicUsedWorkflows");
  }
}
class ue extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicUsedViews");
  }
}
class pe extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicUsedColumns");
  }
}
class ve extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "sentimentUsedColumns");
  }
}
class Ce extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "sentimentRemovedFromColumns");
  }
}
class xe extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "sentimentUsedViews");
  }
}
class Ee extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "sentimentUsedWorkflows");
  }
}
class we extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "sentimentUsedSearch");
  }
}
class Se extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "sentimentUsedSort");
  }
}
class Ae extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "contactSentimentConversationsOpened");
  }
}
class ge extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "docsArticleCreated");
  }
}
class fe extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "docsAiAnswersPromoClicked");
  }
}
class u extends s {
  constructor(n) {
    if (!n.inboxForwarderContext && typeof window < "u") {
      const o = window.location.pathname.includes("/settings/inbox");
      super({
        ...n,
        inboxForwarderContext: o ? "inbox-settings" : "setup-guide"
      });
    } else
      super(n);
  }
}
class ke extends u {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxForwarderCancelClicked");
  }
}
class ye extends u {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxForwarderConnectChannelsClicked");
  }
}
class be extends u {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxForwarderConnectDifferentEmailClicked");
  }
}
class he extends u {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxForwarderFinishLaterClicked");
  }
}
class Te extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companySidebarToggled");
  }
}
class Ie extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companyListOpened");
  }
}
class Re extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companyProfileOpened");
  }
}
class Oe extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companyProfileTabOpened");
  }
}
class Pe extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companySidepanelOpened");
  }
}
class Ve extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companyProfileEditSaved");
  }
}
class _e extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companyPropertiesUpsellClicked");
  }
}
class De extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companyOverviewTimeframeChanged");
  }
}
class Me extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "contactProfileTabOpened");
  }
}
class Ue extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "contactCreated");
  }
}
class Fe extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "improvementAdded");
  }
}
class Be extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "improvementUpdated");
  }
}
class Ge extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "improvementDeleted");
  }
}
class Le extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "improveButtonClicked");
  }
}
class We extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "improvementGenerated");
  }
}
class f extends s {
}
class Ne extends f {
  constructor() {
    super(...arguments);
    t(this, "name", 'In App Tour "Next" Button Clicked');
  }
}
class Ke extends f {
  constructor() {
    super(...arguments);
    t(this, "name", 'In App Tour "Close" Button Clicked');
  }
}
class Ye extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxBlankSlateClicked");
  }
}
class $e extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxConnectBannerClicked");
  }
}
class He extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxWelcomeModalClicked");
  }
}
class je extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "setupGuideStepViewed");
  }
}
class Je extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "setupGuideStepCtaClicked");
  }
}
class ze extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "setupGuideHelpLinkClicked");
  }
}
class Xe extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "setupGuideDismissed");
  }
}
class qe extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "setupGuideRestored");
  }
}
class k extends s {
}
class Qe extends k {
  constructor() {
    super(...arguments);
    t(this, "name", "viewClosedConversationsIncluded");
  }
}
class Ze extends k {
  constructor() {
    super(...arguments);
    t(this, "name", "viewClosedConversationsExcluded");
  }
}
class C extends s {
}
class x extends s {
}
class en extends C {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsMenuOpened");
  }
}
class nn extends C {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsAddMenuOpened");
  }
}
class tn extends C {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsReset");
  }
}
class sn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsReordered");
  }
}
class an extends x {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnAdded");
  }
}
class on extends x {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnRemoved");
  }
}
class dn extends x {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnHeaderClicked");
  }
}
class ln extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "viewSorted");
  }
}
class cn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsCopyModalOpened");
  }
}
class rn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsCopyModalClosed");
  }
}
class mn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsCopyModalSelectAllClicked");
  }
}
class un extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsCopyModalClearAllClicked");
  }
}
class pn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsCopied");
  }
}
class vn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAnswersEnabled");
  }
}
class Cn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAnswersDisabled");
  }
}
class xn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxAiAnswersEnabled");
  }
}
class En extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxAiAnswersDisabled");
  }
}
class wn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "prepaidAiAnswersContactUsClicked");
  }
}
class Sn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "prepaidAiAnswersManageClicked");
  }
}
class An extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "threadReactionAdded");
  }
}
class gn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "threadReactionRemoved");
  }
}
class fn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "inAppBeaconMessageShown");
  }
}
class kn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "beaconSetupStarted");
  }
}
class yn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "beaconContactStepCompleted");
  }
}
class bn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "beaconCustomizeStepCompleted");
  }
}
class hn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "beaconSelfServiceStepCompleted");
  }
}
class Tn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "beaconSetupCompleted");
  }
}
class In extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentCreated");
  }
}
class Rn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentDeleted");
  }
}
class On extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentPublished");
  }
}
class Pn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentTestSessionStarted");
  }
}
class Vn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentDocSourceAdded");
  }
}
class _n extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentDocSourceRemoved");
  }
}
class Dn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentWebsiteSourceAdded");
  }
}
class Mn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentWebsiteSourceRemoved");
  }
}
class Un extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentNameChanged");
  }
}
class Fn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentIdentityChanged");
  }
}
class Bn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentConnectionActivated");
  }
}
class Gn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupStepViewed");
  }
}
class Ln extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupStepCompleted");
  }
}
class Wn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupCancelled");
  }
}
class Nn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupSourceAdded");
  }
}
class Kn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupSourceRemoved");
  }
}
class Yn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupCompleted");
  }
}
class $n extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupStarted");
  }
}
class Hn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupNextClicked");
  }
}
class jn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupBackClicked");
  }
}
class Jn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupTryItOutClicked");
  }
}
class zn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupAddKnowledgeClicked");
  }
}
class Xn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAnswersSimulationStarted");
  }
}
class qn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "globalBannerCtaClicked");
  }
}
class Qn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "guardrailGenerated");
  }
}
class Zn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "guardrailAdded");
  }
}
class et extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "guardrailUpdated");
  }
}
class nt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "guardrailDeleted");
  }
}
class tt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "experienceKit");
  }
}
class st extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "roadblockFooterCtaClicked");
  }
}
class at extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "roadblockCancellationBridgeLanded");
  }
}
class ot extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "scoutCtaClicked");
  }
}
class it extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "scoutKnowledgeAdded");
  }
}
class dt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "scoutExclusionAdded");
  }
}
class lt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "scoutRoleCreated");
  }
}
class ct extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "showOriginalClicked");
  }
}
class rt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "customerPortalSettingsViewed");
  }
}
class mt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "customerPortalSettingsSaved");
  }
}
class ut extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "customerPortalEnabled");
  }
}
class pt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "customerPortalDisabled");
  }
}
class vt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "channelConnectClicked");
  }
}
class Ct extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "channelConnectionSubmitted");
  }
}
class xt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "channelConnectSetupCancelled");
  }
}
class Et extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "channelDisconnectClicked");
  }
}
class wt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "slaOnboardingViewed");
  }
}
class St extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "slaCreateStarted");
  }
}
class At extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "slaPolicyCreated");
  }
}
class gt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "slaPolicyToggled");
  }
}
class ft extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "slaPoliciesReordered");
  }
}
class kt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "slaLearnMoreClicked");
  }
}
function yt() {
  const e = window.hsGlobal.accountDropdown;
  return e != null && e.isOwner ? "owner" : e != null && e.isAdmin ? "admin" : e != null && e.isLightUser ? "light user" : "user";
}
class c extends s {
  getTrackableProperties() {
    return { ...super.getTrackableProperties(), user_role: yt() };
  }
}
class bt extends c {
  constructor() {
    super(...arguments);
    t(this, "name", "reportViewed");
  }
}
class ht extends c {
  constructor() {
    super(...arguments);
    t(this, "name", "reportFilterChanged");
  }
}
class Tt extends c {
  constructor() {
    super(...arguments);
    t(this, "name", "reportDrilldownOpened");
  }
}
class It extends c {
  constructor() {
    super(...arguments);
    t(this, "name", "reportExported");
  }
}
class Rt extends c {
  constructor() {
    super(...arguments);
    t(this, "name", "reportViewSaved");
  }
}
class Ot extends c {
  constructor() {
    super(...arguments);
    t(this, "name", "reportViewSelected");
  }
}
class Pt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "triageSuggestionsShown");
  }
}
class Vt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "triageSuggestionAccepted");
  }
}
const w = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AccountDropdownItemClickedEvent: X,
  AccountDropdownOpenedEvent: z,
  AiAgentConnectionActivatedEvent: Bn,
  AiAgentCreatedEvent: In,
  AiAgentDeletedEvent: Rn,
  AiAgentDocSourceAddedEvent: Vn,
  AiAgentDocSourceRemovedEvent: _n,
  AiAgentIdentityChangedEvent: Fn,
  AiAgentNameChangedEvent: Un,
  AiAgentPublishedEvent: On,
  AiAgentSetupAddKnowledgeClickedEvent: zn,
  AiAgentSetupBackClickedEvent: jn,
  AiAgentSetupCancelledEvent: Wn,
  AiAgentSetupCompletedEvent: Yn,
  AiAgentSetupNextClickedEvent: Hn,
  AiAgentSetupSourceAddedEvent: Nn,
  AiAgentSetupSourceRemovedEvent: Kn,
  AiAgentSetupStartedEvent: $n,
  AiAgentSetupStepCompletedEvent: Ln,
  AiAgentSetupStepViewedEvent: Gn,
  AiAgentSetupTryItOutClickedEvent: Jn,
  AiAgentTestSessionStartedEvent: Pn,
  AiAgentWebsiteSourceAddedEvent: Dn,
  AiAgentWebsiteSourceRemovedEvent: Mn,
  AiAnswersDisabledEvent: Cn,
  AiAnswersEnabledEvent: vn,
  AiAnswersSimulationStartedEvent: Xn,
  AvailabilityChangedEvent: Q,
  AvailabilityToggleClickedEvent: q,
  BeaconContactStepCompletedEvent: yn,
  BeaconCustomizeStepCompletedEvent: bn,
  BeaconSelfServiceStepCompletedEvent: hn,
  BeaconSetupCompletedEvent: Tn,
  BeaconSetupStartedEvent: kn,
  ChannelConnectClickedEvent: vt,
  ChannelConnectSetupCancelledEvent: xt,
  ChannelConnectionSubmittedEvent: Ct,
  ChannelDisconnectClickedEvent: Et,
  ClickedButtonEvent: H,
  ClickedLinkEvent: j,
  CompanyListOpenedEvent: Ie,
  CompanyOverviewTimeframeChangedEvent: De,
  CompanyProfileEditSavedEvent: Ve,
  CompanyProfileOpenedEvent: Re,
  CompanyProfileTabOpenedEvent: Oe,
  CompanyPropertiesUpsellClickedEvent: _e,
  CompanySidebarToggledEvent: Te,
  CompanySidepanelOpenedEvent: Pe,
  ContactCreatedEvent: Ue,
  ContactProfileTabOpenedEvent: Me,
  ContactSentimentConversationsOpenedEvent: Ae,
  CustomerPortalDisabledEvent: pt,
  CustomerPortalEnabledEvent: ut,
  CustomerPortalSettingsSavedEvent: mt,
  CustomerPortalSettingsViewedEvent: rt,
  DocsAiAnswersPromoClickedEvent: fe,
  DocsArticleCreatedEvent: ge,
  ExperienceKitEvent: tt,
  GlobalBannerCtaClickedEvent: qn,
  GuardrailAddedEvent: Zn,
  GuardrailDeletedEvent: nt,
  GuardrailGeneratedEvent: Qn,
  GuardrailUpdatedEvent: et,
  ImproveButtonClickedEvent: Le,
  ImprovementAddedEvent: Fe,
  ImprovementDeletedEvent: Ge,
  ImprovementGeneratedEvent: We,
  ImprovementUpdatedEvent: Be,
  InAppBeaconMessageShownEvent: fn,
  InAppTourCloseButtonClickedEvent: Ke,
  InAppTourNextButtonClickedEvent: Ne,
  InboxAiAnswersDisabledEvent: En,
  InboxAiAnswersEnabledEvent: xn,
  InboxBlankSlateClickedEvent: Ye,
  InboxConnectBannerClickedEvent: $e,
  InboxForwarderCancelClickedEvent: ke,
  InboxForwarderConnectChannelsClickedEvent: ye,
  InboxForwarderConnectDifferentEmailClickedEvent: be,
  InboxForwarderFinishLaterClickedEvent: he,
  InboxWelcomeModalClickedEvent: He,
  PageVisitedEvent: $,
  PrepaidAiAnswersContactUsClickedEvent: wn,
  PrepaidAiAnswersManageClickedEvent: Sn,
  ReportDrilldownOpenedEvent: Tt,
  ReportExportedEvent: It,
  ReportFilterChangedEvent: ht,
  ReportViewSavedEvent: Rt,
  ReportViewSelectedEvent: Ot,
  ReportViewedEvent: bt,
  RoadblockCancellationBridgeLandedEvent: at,
  RoadblockFooterCtaClickedEvent: st,
  ScoutCtaClickedEvent: ot,
  ScoutExclusionAddedEvent: dt,
  ScoutKnowledgeAddedEvent: it,
  ScoutRoleCreatedEvent: lt,
  SentimentRemovedFromColumnsEvent: Ce,
  SentimentUsedColumnsEvent: ve,
  SentimentUsedSearchEvent: we,
  SentimentUsedSortEvent: Se,
  SentimentUsedViewsEvent: xe,
  SentimentUsedWorkflowsEvent: Ee,
  SetupGuideDismissed: Xe,
  SetupGuideHelpLinkClicked: ze,
  SetupGuideRestored: qe,
  SetupGuideStepCtaClicked: Je,
  SetupGuideStepViewed: je,
  ShowOriginalClickedEvent: ct,
  SignedUpEvent: J,
  SlaCreateStartedEvent: St,
  SlaLearnMoreClickedEvent: kt,
  SlaOnboardingViewedEvent: wt,
  SlaPoliciesReorderedEvent: ft,
  SlaPolicyCreatedEvent: At,
  SlaPolicyToggledEvent: gt,
  ThreadReactionAddedEvent: An,
  ThreadReactionRemovedEvent: gn,
  TopicConvoOverrideEvent: ie,
  TopicUsedColumnsEvent: pe,
  TopicUsedReportsEvent: re,
  TopicUsedSearchEvent: ce,
  TopicUsedViewsEvent: ue,
  TopicUsedWorkflowsEvent: me,
  TopicUserCreatedEvent: ae,
  TopicUserModifiedEvent: oe,
  TopicValueDisabledEvent: le,
  TopicValueEnabledEvent: de,
  TopicsAppliedToInboxEvent: te,
  TopicsDeletedEvent: ne,
  TopicsDisabledEvent: ee,
  TopicsEnabledEvent: Z,
  TopicsReviewNotificationClickedEvent: se,
  TriageSuggestionAcceptedEvent: Vt,
  TriageSuggestionsShownEvent: Pt,
  ViewClosedConversationsExcludedEvent: Ze,
  ViewClosedConversationsIncludedEvent: Qe,
  ViewColumnAddedEvent: an,
  ViewColumnHeaderClickedEvent: dn,
  ViewColumnRemovedEvent: on,
  ViewColumnSortedEvent: ln,
  ViewColumnsAddMenuOpenedEvent: nn,
  ViewColumnsCopiedEvent: pn,
  ViewColumnsCopyModalClearAllClickedEvent: un,
  ViewColumnsCopyModalClosedEvent: rn,
  ViewColumnsCopyModalOpenedEvent: cn,
  ViewColumnsCopyModalSelectAllClickedEvent: mn,
  ViewColumnsMenuOpenedEvent: en,
  ViewColumnsReorderedEvent: sn,
  ViewColumnsResetEvent: tn
}, Symbol.toStringTag, { value: "Module" })), _t = (e) => {
  const n = e.replace(/Event$/, "");
  return n.length === 0 ? "" : n.charAt(0).toLowerCase() + n.slice(1);
}, Dt = () => {
  const e = {};
  return new Proxy(e, {
    get: (n, a) => {
      const o = Object.keys(w).find(
        (d) => _t(d) === a
      );
      if (!o)
        throw new Error(`No event found for method: ${String(a)}`);
      const i = w[o];
      return (d = {}) => new i(d).track();
    }
  });
}, Nt = Dt();
export {
  Ft as ensureMixpanelFlagsReady,
  Ut as getDistinctId,
  Bt as getMixpanelFlagSync,
  N as getMixpanelVariantValueSync,
  Lt as identify,
  Gt as isMixpanelFlagEnabled,
  Wt as resetIdentity,
  Nt as track
};
